

export const categories = [
    {
        id: '1',
        title: 'Como o SofChef controla meus pedidos?',
        description: `Seus pedidos podem ser realizados de diversas formas em nosso sistema, seja utilizando um de nossos módulos de autoatendimento, como estruturando um modelo de atendimento por garçons treinados para usar nosso sistema.
        Uma vez realizados, os pedidos vão diretamente para a cozinha ou o local que você preferir, otimizando seu fluxo de trabalho e agilizando seus processos para um atendimento mais rápido e eficiênte para o seu cliente!`
    },

    {
        id: '2',
        title: 'O que é o módulo de autoatendimento?',
        description: `Dentro de nossa plataforma, você pode configurar um acesso a um cardápio digital para seus clientes totalmente personalizavel e intuitivo, que funcionará como um serviço de autoatendimento, onde seu cliente poderá realizar pedidos simplesmente utilizando seu próprio dispositivo celular.`
    },
    {
        id: '3',
        title: 'Como controlar minhas mesas no sistema?',
        description: `Suas mesas são todas cadastradas no sistema, de forma simples e rápida, e te darão dentro de nosso sistema uma visão completa de como está o fluxo de pessoas no seu estabelecimento.`
    },
    {
        id: '4',
        title: 'Como funciona o controle de caixa?',
        description: `O caixa pode ser aberto e fechado de forma simples, no intervalo de tempo que desejar. Nós entregamos uma análise completa de todos os pedidos, lançamentos e afins que acontecem dentro do tempo de abertura do seu caixa, além de uma exportação completa do seu relatório você analisar como e onde desejar!`
    },
    {
        id: '5',
        title: 'Como fica o gerenciamento da minha equipe?',
        description: `Sua equipe pode ser integrada completamente de forma simples em nosso sistema. Sem limite máximo de usuários e nada que possa trazer inconveniências para sua equipe. Aqui, você pode controlar tudo o que um colaborador poderá fazer e analisar todos os passos que estão seguindo dentro do sistea. Controle total!`
    },
    {
        id: '6',
        title: 'O SofChef tem alguma solução de emissão fiscal?',
        description: `Entregamos um serviço completo de emissão de notas (NFe e NFCe) para o seu estabelecimento.`
    },
    {
        id: '7',
        title: 'Como fica o cadastro dos meus produtos?',
        description: `De forma simples, você pode cadastrar seus produtos tanto dentro do sistema por formulários que vão te auxiliar a trazer todo o seu catálogo muito rapidamente, quanto utilizando nossa planilha de cadastro de produtos, onde você poderá inserir todas as informações necessárias dos seus produtos e, com um clique, importá-los para nossa plataforma.`
    }
];